import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import Container from '@material-ui/core/Container';
import { login } from 'redux/actions/session.actions';
import LoginIcon from '@mui/icons-material/Login';
import LockIcon from '@mui/icons-material/Lock';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { useFormik } from 'formik';
import { useThunkDispatch, useTypedSelector } from 'hooks';
import * as yup from 'yup';
import { Environment } from 'utils/environment';
import { Box, Paper, InputAdornment, IconButton } from '@material-ui/core';
import { Visibility, VisibilityOff, Person } from '@mui/icons-material';
import { useState } from 'react';

const validationSchema = yup.object({
  username: yup
    // @ts-ignore
    .string('Ingresa nombre de usuario')
    .min(3, 'nombre de usuario debe tener minimo 3 caracteres')
    .max(50, 'nombre de usuario debe tener minimo 50 caracteres')
    .required('Nombre de usuario es requerido'),
  password: yup
    // @ts-ignore
    .string('Ingresa tu contraseña')
    .max(50, 'contraseña debe tener maximo 50 caracteres')
    .required('Contraseña es requerida'),
});

function Copyright() {
  return (
    <Box> 
      <Typography
        variant="body2"
        color="textSecondary"
        align="center"
        style={{ 
          marginTop: '24px',
          fontSize: '0.875rem',
          color: '#666',
          opacity: 0.7
        }}
      >
        {'Copyright © '}
        2021 - 2025
      </Typography>
      <Typography
        variant="caption"
        style={{
          marginTop: '100px',
          fontSize: '0.75rem',
          color: '#666',
          opacity: 0.7
        }}
      >
        v{process.env.REACT_APP_VERSION || '0.1.0'}
      </Typography>
    </Box>
  );
}

function Background() {
  return (
    <div
      className="background"
      style={{
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        zIndex: '-1',
        overflow: 'hidden',
        widows: '100%',
        height: '100dvh',
      }}
    >
      <img
        src={process.env.PUBLIC_URL + 'background.jpg'}
        alt="Background taller"
        width={'100%'}
        height={'100%'}
        style={{
          objectFit: 'cover',
          filter: 'blur(5px)',
          position: 'absolute',
          top: '0',
          left: '0',
          right: '0',
          bottom: '0',
          zIndex: '-1',
        }}
      />

      <div
        style={{
          position: 'absolute',
          top: '0',
          left: '0',
          right: '0',
          bottom: '0',
          zIndex: '-1',
          background: 'rgba(40, 40, 60, 0.5)',
        }}
      ></div>
    </div>
  );
}

export const Login = () => {
  const mySession = useTypedSelector((s) => s.session);
  const dispatch = useThunkDispatch();
  const [showPassword, setShowPassword] = useState(false);

  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      dispatch(login(values.username, values.password));
    },
  });

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Container
      component="main"
      maxWidth="xs"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: '20px',
      }}
    >
      <Background />

      <Paper
        elevation={24}
        style={{
          padding: '48px 40px',
          backgroundColor: 'white',
          borderRadius: '16px',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)',
          textAlign: 'center',
          width: '100%',
          maxWidth: '440px',
          animation: 'fadeIn 0.5s ease-in',
        }}
      >
        <style>
          {`
            @keyframes fadeIn {
              from {
                opacity: 0;
                transform: translateY(-20px);
              }
              to {
                opacity: 1;
                transform: translateY(0);
              }
            }
          `}
        </style>

        <Box mb={2}>
          {!Environment.hideMarks && (
          <Box
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div style={{ width: '300px' }}>
                <img
                  src={process.env.PUBLIC_URL + 'Logo2.png'}
                  alt="App Logo"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                  }} />
              </div>
            </Box>
          )}
        </Box>


        <Typography
          variant="h4"
          style={{
            fontWeight: 700,
            fontSize: '28px',
            color: '#343c89',
            marginBottom: '8px',
          }}
        >
          GEO {Environment.Country}
        </Typography>

        <Typography
          variant="body2"
          style={{
            color: '#666',
            marginBottom: '32px',
            fontSize: '14px',
          }}
        >
          Ingresa tus credenciales para continuar
        </Typography>

        <form onSubmit={formik.handleSubmit}>
          <TextField
            onChange={formik.handleChange}
            variant="outlined"
            margin="normal"
            fullWidth
            id="username"
            label="Nombre de Usuario"
            name="username"
            autoComplete="username"
            inputProps={{ maxLength: 50 }}
            autoFocus
            value={formik.values.username}
            error={formik.touched.username && Boolean(formik.errors.username)}
            helperText={
              (formik.touched.username && formik.errors.username) ||
              (Boolean(mySession.error?.name === '1008') && 'Nombre de usuario no válido')
            }
            title="Por favor, ingresa tu usuario"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Person style={{ color: '#343c89' }} />
                </InputAdornment>
              ),
              style: {
                borderRadius: '8px',
              }
            }}
            style={{ marginBottom: '20px' }}
          />

          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            onChange={formik.handleChange}
            value={formik.values.password}
            error={formik.touched.password && Boolean(formik.errors.password)}
            helperText={formik.touched.password && formik.errors.password}
            name="password"
            inputProps={{ maxLength: 50 }}
            label="Contraseña"
            type={showPassword ? 'text' : 'password'}
            id="password"
            autoComplete="current-password"
            title="Por favor, ingresa tu contraseña"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <LockIcon style={{ color: '#343c89' }} />
                </InputAdornment>
              ),
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    aria-label="toggle password visibility"
                    onClick={handleClickShowPassword}
                    edge="end"
                  >
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
              style: {
                borderRadius: '8px',
              }
            }}
            style={{ marginBottom: '24px' }}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            startIcon={!mySession.isLoading && <LoginIcon />}
            disabled={mySession.isLoading}
            style={{
              marginBottom: '16px',
              padding: '12px',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: 600,
              textTransform: 'none',
              boxShadow: mySession.isLoading 
                ? 'none' 
                : '0 4px 15px rgba(52, 60, 137, 0.3)',
              transition: 'all 0.3s ease',
            }}
            onMouseEnter={(e) => {
              if (!mySession.isLoading) {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(52, 60, 137, 0.5)';
              }
            }}
            onMouseLeave={(e) => {
              if (!mySession.isLoading) {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(52, 60, 137, 0.3)';
              }
            }}
          >
            {mySession.isLoading ? (
              <CircularProgress size={24} style={{ color: 'white' }} />
            ) : (
              'Ingresar'
            )}
          </Button>
        </form>

        {mySession.error?.name && (
          <Box
            style={{
              color: '#721c24',
              backgroundColor: '#f8d7da',
              border: '1px solid #f5c6cb',
              padding: '12px 16px',
              borderRadius: '8px',
              marginTop: '16px',
              display: 'flex',
              alignItems: 'center',
              animation: 'fadeIn 0.3s ease-in',
            }}
          >
            <Typography
              variant="body2"
              style={{
                flex: 1,
                wordBreak: 'break-word',
                fontSize: '14px',
                fontWeight: 500,
                textAlign: 'center',
                lineHeight: '1.5',
              }}
            >
              {mySession.error.message || ''}
            </Typography>
          </Box>
        )}

        <Copyright />
      </Paper>
      
    </Container>
  );
};
